import { CSSObject } from '@emotion/react';

const detailPtagStyles: CSSObject = {
  textDecoration: 'underline',
  cursor: 'pointer',
};

export { detailPtagStyles };
